import { graphql } from "gql";

const GET_GROUP_SERVICES = graphql(`
  query GetGroupServices($groupName: String!) {
    group(groupName: $groupName) {
      name
      serviceAttributes
    }
  }
`);

const GET_STAKEHOLDER_TRIAL = graphql(`
  query GetStakeholderTrial {
    me {
      userEmail
      trial {
        completed
        extensionDate
        extensionDays
        startDate
        state
      }
    }
  }
`);

const UPDATE_TOURS = graphql(`
  mutation updateTours(
    $newGroup: Boolean!
    $newRoot: Boolean!
    $welcome: Boolean!
  ) {
    updateTours(
      tours: { newGroup: $newGroup, newRoot: $newRoot, welcome: $welcome }
    ) {
      success
    }
  }
`);

const GET_USER_ORGANIZATIONS = graphql(`
  query GetUserOrganizations {
    me {
      __typename
      userEmail
      organizations {
        name
      }
    }
  }
`);

const GET_ORGANIZATION_PERMISSIONS = graphql(`
  query GetOrganizationPermissions($organizationName: String!) {
    organizationId(organizationName: $organizationName) {
      id
      name
      permissions
    }
  }
`);

const GET_GROUP_TRANSLATION_STATUS = graphql(`
  query GetGroupTranslationStatus($groupName: String!) {
    group(groupName: $groupName) {
      description
      language
      name
      translationStatus
    }
  }
`);

export {
  GET_GROUP_SERVICES,
  GET_GROUP_TRANSLATION_STATUS,
  GET_ORGANIZATION_PERMISSIONS,
  GET_STAKEHOLDER_TRIAL,
  GET_USER_ORGANIZATIONS,
  UPDATE_TOURS,
};
